import { colorStrings, mediaQueriesBP } from "@iewc/Utilities/variables";
import { searchInputWidth } from "@iewc/WidgetExtensions/Header//MainNavigationExtension";
import { commonSearchHeaderStyles } from "@iewc/WidgetExtensions/Header/SearchInputExtension";
import { searchHistoryStyles as styles } from "@insite/content-library/Widgets/Header/SearchHistory";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        display: flex;
        flex-direction: column;
        padding: 16px;
        ${mediaQueriesBP.minLG} {
            padding: 10px 40px 40px;
            position: relative;
        }

        ${searchInputWidth};
    `,
};

styles.headerText = {
    ...styles.headerText,
    ...commonSearchHeaderStyles,
};

styles.clearLink = {
    color: colorStrings.primaryMain,
    typographyProps: {
        color: colorStrings.primaryMain,
        size: 12,
    },
    css: css`
        ${mediaQueriesBP.minLG} {
            position: absolute;
            right: 40px;
            top: 30px;
        }
    `,
};

styles.link = {
    color: colorStrings.primaryMain,
    mergeCss: true,
    typographyProps: {
        color: colorStrings.primaryMain,
        size: 14,
    },
};

styles.icon = {
    ...styles.icon,
    css: css`
        margin-right: 0;

        svg {
            height: 14px;
            width: 14px;
        }
    `,
};
